import {Box, Typography} from "@mui/material"
import React from "react"
import {AppButton} from "@app-core/AppButton"
import {NAVY} from "theme"

interface EligibilityStartViewProps {
  onStart: () => void
}

// Screen 6: Transition. Left-aligned, "Benefits Check" heading, body unbold
// except "about 5 minutes".
export const EligibilityStartView: React.FC<EligibilityStartViewProps> = (
  props: EligibilityStartViewProps
) => {
  const {onStart} = props

  return (
    <Box padding={{xs: 3, sm: 6}}>
      <Typography
        component="h1"
        fontWeight="bold"
        fontSize={{xs: "24px", sm: "28px"}}
        color={NAVY}
        marginBottom={3}
      >
        Benefits Check
      </Typography>
      <Typography fontSize="20px" color={NAVY} lineHeight={1.6}>
        The following questions should take{" "}
        <Box component="span" fontWeight="bold">
          about 5 minutes
        </Box>{" "}
        and will help determine if you may qualify for the Disability Tax
        Credit.
      </Typography>
      <Box marginTop={4}>
        <AppButton onClick={onStart} sx={{minWidth: "260px"}}>
          Start Benefits Check
        </AppButton>
      </Box>
    </Box>
  )
}

export default EligibilityStartView
